export const CHECKLIST_STATUS_OPTIONS = ['B', 'R', 'M', 'NA'];
export const FUEL_TYPE_OPTIONS = ['Gasolina', 'ACPM'];
export const YES_NO_OPTIONS = ['SI', 'NO'];
export const TIRE_TYPE_OPTIONS = ['HT', 'AT', 'MT'];
export const TREAD_STATUS_OPTIONS = ['B', 'R', 'M'];

const buildItems = (pairs) => pairs.map(([key, label]) => ({ key, label }));

const FORCE_CANASTA_GENERAL_ITEMS = buildItems([
  ['estado_vehiculo', 'Estado Vehículo'],
  ['aseo_vehiculo', 'Aseo del vehículo'],
  ['estado_tapizado', 'Estado del tapizado'],
  ['antena', 'Antena'],
  ['pito_reversa', 'Pito de reversa'],
  ['bocina', 'Bocina'],
  ['parlantes', 'Parlantes'],
  ['estado_radio', 'Estado de radio'],
  ['tapetes', 'Tapetes'],
  ['plumillas', 'Plumillas (limpia-parabrisas)'],
  ['espejos_cabina', 'Espejos de cabina'],
  ['espejo_reversa', 'Espejo de reversa'],
  ['dispositivo_velocidad', 'Dispositivo de velocidad'],
  ['tablero_comandos', 'Tablero de comandos'],
  ['cinturones_seguridad', 'Cinturones de seguridad'],
  ['reloj', 'Reloj'],
  ['vidrio_panoramico', 'Vidrio panorámico'],
  ['eleva_vidrios', 'Eleva-vidrios'],
  ['manijas_internas', 'Manijas internas'],
  ['manijas_externas', 'Manijas externas'],
  ['estado_puertas_1', 'Estado de puertas'],
  ['estado_puertas_2', 'Estado de puertas 2'],
  ['estado_volante', 'Estado del volante'],
  ['frenos', 'Frenos'],
  ['freno_mano', 'Freno de mano'],
  ['palanca_cambios', 'Estado palanca de cambios'],
  ['estado_luces', 'Estado de luces'],
  ['luces_reversa', 'Luces de reversa'],
  ['luces_direccionales', 'Luces de direccionales'],
  ['luces_cabina', 'Luces de cabina'],
  ['luces_altas', 'Luces altas'],
  ['luces_bajas', 'Luces bajas'],
  ['luces_medias', 'Luces medias'],
  ['stop_trasero', 'Stop trasero'],
  ['licuadoras', 'Licuadoras'],
  ['estado_rines', 'Estado de los rines'],
  ['llanta_trasera', 'Estado llanta trasera'],
  ['llantas_delanteras', 'Estado de llantas delanteras'],
  ['llanta_repuesto', 'Estado de llanta de repuesto'],
  ['bomper_delantero', 'Estado de bomper delantero'],
  ['bomper_trasero', 'Estado de bomper trasero'],
  ['manguera_aire', 'Manguera de aire'],
  ['herramientas', 'Herramientas'],
  ['caja_herramientas', 'Caja de herramientas'],
  ['palanca_gato', 'Palanca gato'],
  ['gato', 'Gato'],
  ['tacos', 'Tacos'],
  ['llaves_vehiculo', 'Llaves de vehículo'],
  ['tapa_combustible', 'Tapa de combustible'],
  ['nivel_agua_limpiaparabrisas', 'Nivel de agua de limpiaparabrisas'],
  ['nivel_aceite_motor', 'Nivel de aceite de motor'],
  ['nivel_agua_refrigerante', 'Nivel de agua refrigerante'],
  ['nivel_hidraulico_direccion', 'Nivel de hidráulico de dirección'],
  ['nivel_liquido_frenos', 'Nivel de líquido de frenos'],
]);

const FORCE_HYDRAULIC_ITEMS = buildItems([
  ['tornamesa', 'Tornamesa'],
  ['estabilizadores', 'Estabilizadores'],
  ['sistema_toma_fuerza', 'Sistema del toma fuerza'],
  ['bomba_hidraulica_manguera', 'Bomba hidráulica y manguera'],
  ['alarma_estabilizadores', 'Alarma de estabilizadores'],
  ['estado_estructural', 'Estado estructural'],
  ['conector_giratorio', 'Conector giratorio'],
  ['ganchos_seguros_espigos', 'Ganchos, seguros, espigos y tuercas'],
  ['mandos_manuales', 'Mandos manuales'],
  ['gatos', 'Gatos'],
  ['estado_brazo', 'Estado del brazo'],
  ['estado_extension_brazo', 'Estado extensión del brazo'],
]);

const CANASTA_HYDRAULIC_ITEMS = buildItems([
  ['tornamesa', 'Tornamesa'],
  ['estabilizadores', 'Estabilizadores'],
  ['sistema_toma_fuerza', 'Sistema del toma fuerza'],
  ['bomba_hidraulica_manguera', 'Bomba Hidráulica manguera'],
  ['alarma_estabilizadores', 'Alarma de estabilizadores'],
  ['estado_estructural', 'Estado estructural'],
  ['conector_giratorio', 'Conector giratorio'],
  ['estado_extensiones_brazo', 'Estado extensiones del brazo'],
  ['controles_justin', 'Controles de justin'],
  ['estado_vaso', 'Estado del vaso'],
  ['estado_lainer', 'Estado del lainer'],
  ['mandos_manuales', 'Mandos manuales'],
]);

const EMERGENCY_ITEMS = buildItems([
  ['kit_derrames', 'Kit de derrames'],
  ['botiquin_vehicular', 'Botiquín vehicular'],
  ['conos', 'Conos'],
  ['tacos_emergencia', 'Tacos'],
  ['paletas_pare_siga', 'Paletas de pare y siga'],
  ['logos_vallas', 'Logos y vallas'],
  ['senales', 'Señales'],
  ['extintor_vigencia', 'Estado de extintor / fecha de vigencia'],
]);

const FORCE_PPE_ITEMS = buildItems([
  ['guantes_clase_2', 'Guantes clase 2'],
  ['guantes_proteccion', 'Guantes de protección'],
  ['guantes_carnaza', 'Guantes de carnaza'],
  ['fungas_guantes', 'Fundas para guantes'],
  ['casco_tapa_oidos', 'Casco con tapa-oídos'],
  ['monogafas', 'Monogafas'],
  ['chaleco_reflectivo', 'Chaleco reflectivo'],
  ['corral', 'Corral'],
  ['estrobo_nailon_1', 'Estrobo de nailon 1.00 mts'],
  ['estrobo_nailon_1_5', 'Estrobo de nailon 1.50 mts'],
  ['estrobo_nailon_6', 'Estrobo de nailon 6 mts'],
  ['cadena_eslabones', 'Cadena de eslabones con amarre'],
  ['mona', 'Mona'],
  ['barra', 'Barra'],
  ['barreno_tierra', 'Barreno puesta tierra'],
  ['estrobo_guaya_postes', 'Estrobo de guaya para izaje de postes'],
  ['polines', 'Polines'],
  ['eslinga_amarre', 'Eslinga de amarre'],
  ['laso_vientos', 'Lazo para vientos'],
  ['grilletes', 'Grilletes'],
  ['pallin', 'Pallin'],
  ['zapata_carreto', 'Zapata para carreto'],
]);

const CANASTA_PPE_ITEMS = buildItems([
  ['arnes_dielectrico', 'Arnés dieléctrico'],
  ['equipo_abejas', 'Equipo de protección de abejas'],
  ['eslinga_posicionamiento', 'Eslinga de posicionamiento'],
  ['guantes_dielectricos_c2', 'Guantes dieléctricos clase 2'],
  ['guantes_dielectricos_c4', 'Guantes dieléctricos clase 4'],
  ['guantes_caucho', 'Guantes de caucho'],
  ['guantes_algodon', 'Guantes de algodón'],
  ['maletin_guantes', 'Maletín para guantes'],
  ['mangas_dielectricas_c2', 'Mangas dieléctricas clase 2'],
  ['mangas_dielectricas_c4', 'Mangas dieléctricas clase 4'],
  ['sujetador_mangas', 'Sujetador de mangas dieléctricas'],
  ['tula_porta_mangas', 'Tula porta mangas'],
]);

const CANASTA_TENSION_TOOLS = buildItems([
  ['agarradora_cable', 'Agarradora para cable'],
  ['alicate_aislado', 'Alicate aislado'],
  ['aparejos_aislados', 'Aparejos aislados'],
  ['cinta_metrica', 'Cinta métrica'],
  ['cizallas_aisladas', 'Cizallas aisladas'],
  ['diferencial', 'Diferencial'],
  ['dinamometro', 'Dinamómetro'],
  ['estrobo_manila', 'Estrobo de manila'],
  ['estrobo_acero', 'Estrobo de acero'],
  ['lima_plana', 'Lima plana 6"'],
  ['lima_redonda_triangular', 'Lima redonda y triangular'],
  ['llaves_tipo_copa', 'Juego de llaves tipo copa'],
  ['llaves_mixtas', 'Juego de llaves mixtas'],
  ['maceta', 'Maceta'],
  ['manila_auxiliar', 'Manila 5/8 30m cuerda auxiliar'],
  ['marco_segueta', 'Marco de segueta aislado'],
  ['llave_peston', 'Llave de pestón'],
  ['lampara_reflectiva', 'Lámpara reflectiva'],
  ['linterna', 'Linterna'],
  ['plomada_punto', 'Plomada de punto'],
  ['ponchadora', 'Ponchadora'],
  ['secuenciometro', 'Secuenciómetro'],
  ['zunchadora', 'Zunchadora'],
  ['destornilladores', 'Juego de destornilladores'],
]);

const CANASTA_INSULATED_EQUIPMENT = buildItems([
  ['conector_manguera', 'Conector para manguera'],
  ['cobertor_cortacircuitos_c4', 'Cobertor cortacircuitos C4'],
  ['cobertor_poste', 'Cobertor de poste'],
  ['cobertor_cruceta_c4', 'Cobertor de cruceta C4'],
  ['cobertor_punta_cruceta_c4', 'Cobertor de punta cruceta C4'],
  ['cobertor_punta_poste', 'Cobertor punta de poste'],
  ['cobertor_aisladores_c2', 'Cobertor aisladores C2'],
  ['cobertor_aisladores_c4', 'Cobertor aisladores C4'],
  ['puesta_tierra', 'Puesta a tierra'],
  ['detector_voltaje', 'Detector de voltaje'],
  ['pertiga', 'Pértiga'],
  ['garrucha', 'Garrucha'],
  ['jumper_17kv', 'Jumper 17 kv'],
  ['jumper_36kv', 'Jumper 36 kv'],
  ['cubridores_linea_c2', 'Cubridores de línea C2'],
  ['cubridores_linea_c4', 'Cubridores de línea C4'],
  ['mantas_caucho_abierta', 'Mantas de caucho abierta'],
  ['mantas_caucho_cerrada', 'Mantas de caucho cerrada'],
  ['pinzas_plasticas', 'Pinzas plásticas'],
  ['pinza_voltiamperimetrica', 'Pinza voltiamperimétrica'],
  ['baston_aislado', 'Bastón aislado ganchos espiral / argolla'],
]);

const TURBO_GENERAL_ITEMS = buildItems([
  ['estado_vehiculo', 'Estado Vehículo'],
  ['aseo_vehiculo', 'Aseo del vehículo'],
  ['estado_tapizado', 'Estado del tapizado'],
  ['antena', 'Antena'],
  ['pito_reversa', 'Pito de reversa'],
  ['bocina', 'Bocina'],
  ['parlantes', 'Parlantes'],
  ['estado_radio', 'Estado de radio'],
  ['tapetes', 'Tapetes'],
  ['plumillas', 'Plumillas (limpia-parabrisas)'],
  ['espejos_cabina', 'Espejos de cabina'],
  ['espejo_reversa', 'Espejo de reversa'],
  ['dispositivo_velocidad', 'Dispositivo de velocidad'],
  ['tablero_instrumento', 'Tablero de instrumento'],
  ['cinturones_seguridad', 'Cinturones de seguridad'],
  ['reloj', 'Reloj'],
  ['vidrio_panoramico', 'Vidrio panorámico'],
  ['eleva_vidrios', 'Eleva-vidrios'],
  ['tacometro', 'Tacómetro'],
  ['manijas_internas', 'Manijas internas'],
  ['manijas_externas', 'Manijas externas'],
  ['estado_puertas_1', 'Estado de puertas'],
  ['estado_puertas_2', 'Estado de puertas 2'],
  ['estado_volante', 'Estado del volante'],
  ['frenos', 'Frenos'],
  ['freno_mano', 'Freno de mano'],
  ['palanca_cambios', 'Estado palanca de cambios'],
  ['luces_exploradoras', 'Luces exploradoras'],
  ['luces_reversa', 'Luces de reversa'],
  ['luces_direccionales', 'Luces de direccionales'],
  ['luces_cabina', 'Luces de cabina'],
  ['luces_altas', 'Luces altas'],
  ['luces_bajas', 'Luces bajas'],
  ['luces_medias', 'Luces medias'],
  ['stop_trasero', 'Stop trasero'],
  ['estado_carpa', 'Estado de carpa'],
  ['estado_rines', 'Estado de los rines'],
  ['correa_accesorios', 'Correa de accesorios'],
  ['llanta_trasera', 'Estado llanta trasera'],
  ['llantas_delanteras', 'Estado de llantas delanteras'],
  ['llanta_repuesto', 'Estado de llanta de repuesto'],
  ['parachoque_delantero', 'Estado de parachoque delantero'],
  ['parachoque_trasero', 'Estado de parachoque trasero'],
  ['estado_carroceria', 'Estado de carrocería'],
  ['herramientas', 'Herramientas'],
  ['caja_herramientas', 'Caja de herramientas'],
  ['palanca_gato', 'Palanca gato'],
  ['gato', 'Gato'],
  ['tacos', 'Tacos'],
  ['llaves_vehiculo', 'Llaves de vehículo'],
  ['tapa_combustible', 'Tapa de combustible'],
  ['nivel_agua_limpiaparabrisas', 'Nivel de agua de limpiaparabrisas'],
  ['nivel_aceite_motor', 'Nivel de aceite de motor'],
  ['nivel_agua_refrigerante', 'Nivel de agua refrigerante'],
  ['nivel_liquido_frenos', 'Nivel de líquido de frenos'],
  ['nivel_aceite_direccion', 'Nivel de aceite caja de dirección'],
  ['funcionamiento_motor', 'Funcionamiento del motor'],
]);

const CAMIONETA_GENERAL_ITEMS = buildItems([
  ['estado_vehiculo', 'Estado Vehículo'],
  ['aseo_vehiculo', 'Aseo del vehículo'],
  ['estado_tapizado', 'Estado del tapizado'],
  ['antena', 'Antena'],
  ['pito_reversa', 'Pito de reversa'],
  ['bocina', 'Bocina'],
  ['parlantes', 'Parlantes'],
  ['estado_radio', 'Estado de radio'],
  ['tapetes', 'Tapetes'],
  ['plumillas', 'Plumillas (limpia-parabrisas)'],
  ['espejos_cabina', 'Espejos de cabina'],
  ['espejo_reversa', 'Espejo de reversa'],
  ['dispositivo_velocidad', 'Dispositivo de velocidad'],
  ['tablero_instrumento', 'Tablero de instrumento'],
  ['cinturones_seguridad', 'Cinturones de seguridad'],
  ['reloj', 'Reloj'],
  ['vidrio_panoramico', 'Vidrio panorámico'],
  ['eleva_vidrios', 'Eleva-vidrios'],
  ['tacometro', 'Tacómetro'],
  ['manijas_internas', 'Manijas internas'],
  ['manijas_externas', 'Manijas externas'],
  ['estado_puertas_1', 'Estado de puertas'],
  ['estado_puertas_2', 'Estado de puertas 2'],
  ['estado_volante', 'Estado del volante'],
  ['frenos', 'Frenos'],
  ['freno_mano', 'Freno de mano'],
  ['palanca_cambios', 'Estado palanca de cambios'],
  ['luces_exploradoras', 'Luces exploradoras'],
  ['luces_reversa', 'Luces de reversa'],
  ['luces_direccionales', 'Luces de direccionales'],
  ['luces_cabina', 'Luces de cabina'],
  ['luces_altas', 'Luces altas'],
  ['luces_bajas', 'Luces bajas'],
  ['luces_medias', 'Luces medias'],
  ['stop_trasero', 'Stop trasero'],
  ['estado_carpa', 'Estado de carpa'],
  ['estado_rines', 'Estado de los rines'],
  ['correa_accesorios', 'Correa de accesorios'],
  ['llanta_trasera', 'Estado llanta trasera'],
  ['llantas_delanteras', 'Estado de llantas delanteras'],
  ['llanta_repuesto', 'Estado de llanta de repuesto'],
  ['parachoque_delantero', 'Estado de parachoque delantero'],
  ['parachoque_trasero', 'Estado de parachoque trasero'],
  ['porta_escalera', 'Porta escalera'],
  ['herramientas', 'Herramientas'],
  ['caja_herramientas', 'Caja de herramientas'],
  ['palanca_gato', 'Palanca gato'],
  ['gato', 'Gato'],
  ['tacos', 'Tacos'],
  ['llaves_vehiculo', 'Llaves de vehículo'],
  ['tapa_combustible', 'Tapa de combustible'],
  ['nivel_agua_limpiaparabrisas', 'Nivel de agua de limpiaparabrisas'],
  ['nivel_aceite_motor', 'Nivel de aceite de motor'],
  ['nivel_agua_refrigerante', 'Nivel de agua refrigerante'],
  ['nivel_liquido_frenos', 'Nivel de líquido de frenos'],
  ['nivel_bomba_embrague', 'Nivel de líquido bomba de embrague'],
  ['funcionamiento_motor', 'Funcionamiento del motor'],
]);

const CONFIGS = {
  Fuerza: {
    code: 'FT-TRP-055',
    title: 'Acta de asignación, devolución y responsabilidad vehículo tipo grúa de fuerza',
    sections: [
      { title: '4. Estado general del vehículo', items: FORCE_CANASTA_GENERAL_ITEMS },
      { title: '5. Estado de equipos hidráulico', items: FORCE_HYDRAULIC_ITEMS },
      { title: '6. Estado de equipos de emergencia', items: EMERGENCY_ITEMS },
      { title: '7. Estado elementos de protección personal y equipos izaje de cargas', items: FORCE_PPE_ITEMS },
    ],
  },
  Canasta: {
    code: 'FT-TRP-056',
    title: 'Acta de asignación, devolución y responsabilidad vehículo tipo grúa canasta',
    sections: [
      { title: '4. Estado general del vehículo', items: FORCE_CANASTA_GENERAL_ITEMS },
      { title: '5. Estado de equipos hidráulico', items: CANASTA_HYDRAULIC_ITEMS },
      { title: '6. Estado de equipos de emergencia', items: EMERGENCY_ITEMS },
      { title: '7. Estado elementos de protección personal', items: CANASTA_PPE_ITEMS },
      { title: '8. Estado herramienta básica trabajos con tensión', items: CANASTA_TENSION_TOOLS },
      { title: '9. Estado de equipo aislado', items: CANASTA_INSULATED_EQUIPMENT },
    ],
  },
  Turbo: {
    code: 'FT-TRP-057',
    title: 'Acta de asignación, devolución y responsabilidad vehículo turbo',
    sections: [
      { title: '4. Estado general del vehículo', items: TURBO_GENERAL_ITEMS },
      { title: '5. Estado de equipos de emergencia', items: EMERGENCY_ITEMS },
    ],
  },
  Camioneta: {
    code: 'FT-TRP-059',
    title: 'Acta de asignación, devolución y responsabilidad vehículo camioneta / campero',
    sections: [
      { title: '4. Estado general del vehículo', items: CAMIONETA_GENERAL_ITEMS },
      { title: '5. Estado de equipos de emergencia', items: EMERGENCY_ITEMS },
    ],
  },
};

const COMMON_TEXT_FIELDS = [
  { key: 'project', label: 'Proyecto' },
  { key: 'area', label: 'Área' },
  { key: 'owner_identification', label: 'Identificación del propietario' },
  { key: 'color', label: 'Color' },
  { key: 'engine_number', label: 'Número de motor' },
  { key: 'chassis_number', label: 'Número de chasis' },
  { key: 'owner_name', label: 'Propietario' },
  { key: 'passenger_capacity', label: 'Capacidad de pasajeros' },
  { key: 'driver_role', label: 'Cargo del conductor' },
  { key: 'driver_license_number', label: 'N° licencia de conducción' },
  { key: 'driver_license_categories', label: 'Categoría(s) licencia' },
  { key: 'driver_license_expiry', label: 'Vigencia licencia' },
  { key: 'initial_mileage', label: 'Kilometraje inicial' },
  { key: 'final_mileage', label: 'Kilometraje final' },
  { key: 'next_oil_change_km', label: 'Km próximo cambio de aceite' },
];

export function getVehicleChecklistConfig(vehicleType) {
  return CONFIGS[vehicleType] || null;
}

export function getVehicleChecklistTextFields() {
  return COMMON_TEXT_FIELDS;
}

function normalizePhotoCollection(value) {
  if (!Array.isArray(value)) return [];
  return value
    .map((item, index) => {
      if (typeof item === 'string') {
        const dataUrl = item.trim();
        return dataUrl ? { name: `foto-${index + 1}.jpg`, dataUrl } : null;
      }
      if (item && typeof item === 'object') {
        const dataUrl = String(item.dataUrl || item.url || '').trim();
        if (!dataUrl) return null;
        return {
          name: String(item.name || `foto-${index + 1}.jpg`),
          dataUrl,
        };
      }
      return null;
    })
    .filter(Boolean);
}

export function createChecklistState(vehicleType, seed = null) {
  const config = getVehicleChecklistConfig(vehicleType);
  const statuses = {};
  if (config) {
    config.sections.forEach((section) => {
      section.items.forEach((item) => {
        statuses[item.key] = '';
      });
    });
  }

  const base = {
    vehicle_type: vehicleType || '',
    text: Object.fromEntries(COMMON_TEXT_FIELDS.map((field) => [field.key, ''])),
    fuel_type: '',
    has_vehicle_life_sheet: '',
    has_document_folder: '',
    physical_condition_notes: '',
    physical_condition_photos: [],
    findings_notes: '',
    findings_photos: [],
    hallazgos: Array.from({ length: 7 }, () => ''),
    tire_data: {
      front_reference: '',
      front_type: '',
      rear_reference: '',
      rear_type: '',
      spare_reference: '',
      spare_type: '',
      tread_front_left: '',
      tread_front_right: '',
      tread_rear_left: '',
      tread_rear_right: '',
    },
    statuses,
  };

  if (!seed || typeof seed !== 'object') return base;
  return {
    ...base,
    ...seed,
    vehicle_type: seed.vehicle_type || base.vehicle_type,
    text: { ...base.text, ...(seed.text || {}) },
    tire_data: { ...base.tire_data, ...(seed.tire_data || {}) },
    statuses: { ...base.statuses, ...(seed.statuses || {}) },
    physical_condition_photos: normalizePhotoCollection(seed.physical_condition_photos),
    findings_notes: String(
      seed.findings_notes ||
        (Array.isArray(seed.hallazgos) ? seed.hallazgos.filter(Boolean).join('\n') : '')
    ).trim(),
    findings_photos: normalizePhotoCollection(seed.findings_photos),
    hallazgos: Array.isArray(seed.hallazgos)
      ? Array.from({ length: 7 }, (_, idx) => seed.hallazgos[idx] || '')
      : base.hallazgos,
  };
}
